/*
  File name: index.js
    Program Description:
    - This file initializes all states to the Vuex store library
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { systemMode, systemPrivileges } from 'session-plugin'
import alert from '@/store/alert'
import dialog from '@/store/dialog'
import lookups from '@/store/lookups'
import defaults from '@/store/lookups/defaults'
import notifications from './notifications'
import { session } from './session'
import createMultiTabState from 'vuex-multi-tab-state'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    alert,
    dialog,
    lookups,
    session,
    defaults,
    systemMode,
    notifications,
    systemPrivileges
  },
  plugins: [
    createMultiTabState({
      statesPaths: ['session.triggerSessionState']
    })
  ]
})
